export default function(params, node) {
  var self = this;
  self.$el = $(node);

  self.master_record = ko.observable();
  self.available_records = ko.observableArray([]);
  self.selected_prerequisites = ko.observableArray([]);
  self.config = _.extend({}, self.defaults, params);

  self.init = function() {
    var mapped = ko.mapping.fromJSON(params);
    self.master_record(mapped.master_record);
    self.available_records(mapped.available_masters());
    self.selected_prerequisites(_.filter(self.available_records(), function(record) {
      if (_.contains(mapped.prerequisite_ids(), record.id())) {
        return true;
      }
      return false;
    })
    );
    setTimeout(function() {
      (new Kadenze.KdForms()).update();
    }, 200);
  };

  self.destroy = function(vm) {
    Kadenze.UIUtil.confirmAction('Are you sure you want to delete this master_record?', function() {
      if (self.master_record().id()) {
        var request = new Kadenze.AjaxRequest({
          type: 'DELETE',
          url: Kadenze.Routes.admin_course_master_record_path(self.master_record().id()),
          loadingIndicator: {
            container: self.$el,
            positionTop: 'fixed'
          }
        });

        request.done(function(response) {
          new Kadenze.Notice.success({ message: response.message });
          Kadenze.Request.pjax({url: Kadenze.Routes.admin_course_master_records_path()});
        });

        request.fail(function(response) {
          console.warn('Failed saving master_record: ', response);
          var message = response.responseJSON ? response.responseJSON.message : Kadenze.I18n.t('notice.unexpected_error');
          new Kadenze.Notice.error({ message: message });
        });

      } else {
        Kadenze.Request.pjax({url: Kadenze.Routes.master_record_path()});
      }
    });

  };

  self.save = function() {

    self.prepData();

    var data = ko.mapping.toJS(self.master_record);
    var url = Kadenze.Routes.admin_course_master_record_path(self.master_record().id());
    var method = 'PATCH';

    var request = new Kadenze.AjaxRequest({
      type: method,
      url: url,
      data: { course_master_record: data },
      loadingIndicator: {
        container: self.$el,
        positionTop: 'fixed'
      }
    });

    request.done(function(response) {
      new Kadenze.Notice.success({ message: response.message });
      Kadenze.Request.pjax({url: Kadenze.Routes.admin_course_master_records_path()});
    });

    request.fail(function(response) {
      console.warn('Failed saving program: ', response);
      var message = response.responseJSON ? response.responseJSON.message : Kadenze.I18n.t('notice.unexpected_error');
      new Kadenze.Notice.error({ message: message });
    });

    return request;
  };

  self.prepData = function() {
    self.master_record().prerequisite_course_ids(_.map(self.selected_prerequisites(), function(item) {
      return item.id();
    }));
  };

  self.init();

  return self;
}
